
import { format } from "date-fns";

interface PaymentDueDateDisplayProps {
  paymentDueDate: Date | null;
  paymentTermType: string;
}

export const PaymentDueDateDisplay = ({ paymentDueDate, paymentTermType }: PaymentDueDateDisplayProps) => {
  if (!paymentDueDate) return null;

  return (
    <div className="bg-muted p-4 rounded-md">
      <div className="font-medium">
        <span>Payment Due Date: </span>
        <span className="text-primary">
          {paymentTermType === "upfront" 
            ? "Due immediately (Today)" 
            : format(paymentDueDate, "PPP")
          }
        </span>
      </div>
    </div>
  );
};
